import { Dropdown } from '../Dropdown';
import { Label, Row } from './TimeslotRow.styles';
import type { TimeslotRowProps } from './TimeslotRow.types';

export function TimeslotRow({
  label,
  timeslots,
  selectedTimeslot,
  onChange,
  timeslotPlaceholder = 'Time*',
  ariaLabelFormatter = (l) => `${l} time`,
}: TimeslotRowProps) {
  return (
    <Row>
      <Label>{label}</Label>
      <Dropdown
        options={timeslots}
        value={selectedTimeslot}
        placeholder={timeslotPlaceholder}
        onChange={onChange}
        aria-label={ariaLabelFormatter(label)}
      />
    </Row>
  );
}
